import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"

import { cleanEmptyParams } from "@/utilities/etc"
import { Crumb } from "@/utilities/types/local"
import welcomeTokenStorage from "@/utilities/WelcomeTokenStorage"

export const Route = createFileRoute("/_authenticated/account/passes")({
  staticData: {
    pageName: "Passes",
  },
  validateSearch: (
    search: Record<string, unknown>
  ): { qrLookupID?: string } => {
    return cleanEmptyParams({
      qrLookupID: (search.qrLookupID as string) || "",
    })
  },
  beforeLoad: ({ search }) => {
    // If qrLookupID is provided, validate it against stored session
    // If invalid, redirect to welcome with the stored qrLookupID to fetch a fresh token
    if (search.qrLookupID) {
      const isValid = welcomeTokenStorage.validateQrLookupID(search.qrLookupID)
      if (!isValid) {
        const storedQrLookupID = welcomeTokenStorage.getQrLookupID()
        if (storedQrLookupID) {
          throw redirect({
            to: "/qr/$qrLookupID/welcome",
            params: { qrLookupID: storedQrLookupID },
          })
        }
      }
    }
  },
  loader: () => {
    return {
      crumb: { translationKey: "park:myPasses.header" } as Crumb,
    }
  },
  component: Outlet,
})
